<p-select
  [options]="options()"
  [(ngModel)]="value"
  (ngModelChange)="onValueChange($event)"
  optionLabel="label"
  optionValue="value"
  [placeholder]="placeholder()"
  [showClear]="showClear()"
  [disabled]="disabled"
  [appendTo]="appendTo()"
  [ngClass]="{
    'ng-invalid ng-dirty': ngControl?.control?.invalid && ngControl?.control?.touched,
  }"
  class="payment-plan-select w-full"
></p-select>
